import ApiClient from './ApiClient';

// QM §5.9 audit log — read-only, supervisor/admin scoped.
// Filters accepted by the backend: queue_id, conversation_id, actor_id,
// agent_id, event_type, since, until, page.
class QueueAuditEventsAPI extends ApiClient {
  constructor() {
    super('queue_audit_events', { accountScoped: true });
  }

  list(params) {
    return axios.get(this.url, { params });
  }

  // QM §5.9(3) — the export runs as a background job: this only enqueues it.
  startExport(params) {
    return axios.post(`${this.url}/export`, params);
  }

  // QM §5.9(3) — pending / running / completed / failed; carries download_url once ready.
  exportStatus() {
    return axios.get(`${this.url}/export_status`);
  }
}

export default new QueueAuditEventsAPI();
